module.exports = __webpack_public_path__ + "static/media/loc7_img8.9131130a.jpg";